The URL of the privacy policy to show to the candidate.

The `url` field has a maximum length of 1,000 characters.
